import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { patientFeedBackData } from "../../thirdUtils/constant";
import patientFeedbackquotes from "../../thirdAssets/Images/patient-feedback-quotes.png"

const PatientFeedback = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000
    }
    return (
        <div className="third-design-patient-feedback-main">
            <div className="third-design-patient-feedback-left-div"></div>
            <div className="third-design-patient-feedback-right-div">
                <div className="third-design-patient-text-div">
                    <h2 data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">{selectedLanguage?.txt_testimonial}</h2>
                    <h1>{selectedLanguage?.txt_what_customer_says}</h1>
                    <img src={patientFeedbackquotes} alt="" />
                </div>
                <Slider className="third-design-feedback-slider" {...settings}>
                    {
                        patientFeedBackData?.map((v, i) => {
                            return (
                                <div className="third-design-patient-feedback-slider-text" key={i}>
                                    <p>"{selectedLanguage?.txt_it_is_very_important_to_take}"</p>
                                    <img src={v?.img} alt="" />
                                    <h2>
                                        {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                    </h2>
                                    <h5>
                                        {isELSelect ? v?.role : (isAlSelect ? v?.alRole : v?.glRole)}
                                    </h5>
                                </div>
                            )
                        })
                    }
                </Slider>
            </div>
        </div>
    )
}

export default PatientFeedback